import { noticeableWidgetId } from '@/environment';
import { useAnalytics } from '@/services/analytics';
import { _noticableOpen } from '@/state/layout/noticable';
import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';
import { useCallback, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import ExpandableButton from '../Buttons/ExpandableButton';
import confetti from './images/confetti.svg';

const StyledExpandableButton = styled(ExpandableButton)`
    margin-top: auto;
`;

interface Props {
    sidebarWidth: string;
    hideDetails?: boolean;
    iconColor?: string;
}

export const WhatsNew = ({ sidebarWidth, hideDetails, iconColor }: Props) => {
    const mixpanel = useAnalytics();
    const [isWhatsNewOpen, setIsWhatsNewOpen] = useRecoilState(_noticableOpen);
    const [isWhatsNewOpenOnce, setWhatsNewOpenOnce] = useState(false);

    const renderNoticable = useCallback((redo: boolean = false) => {
        if (redo) {
            noticeable?.do('widget:open', noticeableWidgetId);
        } else {
            noticeable?.render('widget', noticeableWidgetId);
        }
    }, []);

    useEffect(() => {
        renderNoticable(isWhatsNewOpen);
    }, [isWhatsNewOpen]);

    useEffect(() => {
        return () => {
            setIsWhatsNewOpen(false);
        };
    }, []);

    useEffect(() => {
        if (isWhatsNewOpenOnce) {
            mixpanel?.track('whats-new', { event: 'click' });
        }
    }, [isWhatsNewOpenOnce]);

    const onWhatsNewClick = () => {
        setWhatsNewOpenOnce(true);
        setIsWhatsNewOpen(!isWhatsNewOpen);
        renderNoticable();
    };

    return (
        <>
            <StyledExpandableButton
                id="noticeable-widget"
                ariaLabel="New in D-ID"
                icon={confetti}
                isOpen={true}
                onClick={onWhatsNewClick}
                {...(iconColor ? { iconStyleOverride: () => ({ '&::after': { backgroundColor: iconColor } }) } : {})}>
                {!hideDetails && <span>New in D-ID</span>}
            </StyledExpandableButton>
            <Global
                styles={css`
                    .noticeable-widget-view {
                        right: unset !important;
                        left: ${sidebarWidth} !important;
                        top: unset !important;
                        bottom: 100px !important;
                    }
                `}
            />
        </>
    );
};
